'use client';
import React from 'react';
import SymbolMenu from './SymbolMenu';
import { ChartDataType } from './types';

const ReactECharts = React.lazy(() => import('echarts-for-react'));

export interface ChartProps {
  currentSymbol: string;
  symbols: string[];
  chartData: ChartDataType;
  options?: any;
  addSymbol: (symbol: string) => void;
  removeSymbol: (symbol: string) => void;
}

export const Chart: React.FC<ChartProps> = ({
  addSymbol,
  chartData,
  currentSymbol,
  options,
  removeSymbol,
  symbols,
}) => {
  return (
    <div className="flex flex-col-reverse md:flex-row w-full mt-4 min-h-[375px]">
      <div className="w-full lg:w-9/12">
        <ReactECharts
          className="border border-bzblue-300 bg-white"
          notMerge={true}
          option={options}
          style={{ height: '375px', width: '100%' }}
        />
      </div>
      <div className="w-full lg:w-3/12">
        <SymbolMenu
          chartData={chartData}
          currentSymbol={currentSymbol}
          onAddSymbol={addSymbol}
          onRemoveSymbol={removeSymbol}
          symbols={symbols}
        />
      </div>
    </div>
  );
};

export default Chart;

